import React from "react";
import "./ProjectListContent.css";

function ProjectListContent({ content }) {
  // Sort the content array by sortOrder
  const sortedContent = content.sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="projectcontent-list">
      {sortedContent.map((item) => (
        <div key={item.id} className="projectcontent-item">
          <div>
            <h3 className="projectcontent-title">{item.name}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
              className="projectcontent-description"
            ></p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProjectListContent;
